import { Button } from "@mui/material";
import { Empty, Flex, IconBadge } from "@zfp-akademie-a-s/zfp-design";
import { WarningIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { QuestionnaireStatus } from "Infrastructure/ApiZfp/Schema";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useQuestionnaireContext } from "./QuestionnaireContext";
import { isExpiredStatus } from "./utils";

type Props = {
  onReEvaluate: () => void;
  status: QuestionnaireStatus;
};

const getContent = (status: QuestionnaireStatus) => {
  if (isExpiredStatus(status)) {
    return {
      titleKey: Resources.Questionnaire.Expired.Title,
      textKey: Resources.Questionnaire.Expired.Text,
      actionKey: Resources.Questionnaire.Expired.Action,
    };
  }

  return {
    titleKey: Resources.Questionnaire.QuestionsModified.Title,
    textKey:
      status === QuestionnaireStatus.nsure_questions_changed
        ? Resources.Questionnaire.QuestionsModified.TextNsureChanged
        : Resources.Questionnaire.QuestionsModified.TextGoalsChanged,
    actionKey: Resources.Questionnaire.QuestionsModified.Action,
  };
};

export const QuestionnaireReEvaluationRequired = ({ onReEvaluate, status }: Props) => {
  const { t } = useResource();
  const { isReadOnly } = useQuestionnaireContext();

  const { titleKey, textKey, actionKey } = getContent(status);

  return (
    <Flex pt={Spacing.XXL} justifyContent="center">
      <Empty
        title={t(titleKey)}
        text={t(textKey)}
        icon={<IconBadge color="warning" icon={<WarningIcon sx={{ fontSize: 35 }} />} />}
        actions={
          <Button variant="contained" onClick={onReEvaluate} disabled={isReadOnly}>
            {t(actionKey)}
          </Button>
        }
      />
    </Flex>
  );
};
